<template>
  <section
    v-if="!userHasSubscription"
    :class="['boogo__section', isBooGoPage && 'boogo__section--boogo-page']"
  >
    <div class="boogo__content">
      <div class="boogo__content-info">
        <div class="boogo__content-info-boogo-logo-wrapper">
          <BooGoLogo class="boogo__content-info-boogo-logo" />
        </div>
        <div class="boogo__content-info-text">
          INDIVIDUALS CAN Buy 1 year of premium & get 1 year
        </div>
        <div :class="['boogo__discount-wrapper', !isBooGoPage && 'boogo__discount-wrapper--mb-40']">
          <BooGoDiscount class="boogo__discount" />
        </div>
        <div class="boogo__actions">
          <router-link
            :to="{ name: 'boogo' }"
            :class="[
              'btn btn--primary boogo__content-info-button',
              isBooGoPage && 'boogo__content-info-button--hide',
            ]"
          >
            Shop BooGo!
          </router-link>
          <div v-if="!isBooGoPage" class="boogo__lets-talk">
            Looking for BooGo savings for your team?
            <a target="_blank" :href="letsTalkLink" class="boogo__lets-talk-link"> Let’s talk </a>
          </div>
        </div>
      </div>
      <div class="boogo__pumpkin-wrapper">
        <img :src="BooGoHeroSectionImg" alt="boogo promos are back!" class="boogo__pumpkin-img" />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { utmParamsUtils, routesRules } from '@/helpers/mixins'
import BooGo from '@/assets/images/hero-section/boogo/boogo_logo.svg'
import BooGoDiscount from '@/assets/images/hero-section/boogo/boogo_discount-percent.svg'
import BooGoHeroSectionImgPng from '@/assets/images/hero-section/boogo/boogo_pumpkin-light.png'

export default {
  name: 'BooGoHeroSection',
  mixins: [utmParamsUtils, routesRules],
  data() {
    return {
      navigatorUserAgent: false,
    }
  },
  components: {
    BooGoLogo: { ...BooGo, name: 'BooGo' },
    BooGoDiscount: { ...BooGoDiscount, name: 'BooGoDiscount' },
  },
  computed: {
    ...mapState({
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
    }),
    userHasSubscription() {
      return this.usersCurrentSubscriptions.length > 0
    },
    letsTalkLink() {
      const UTMParamsString =
        this.setUTMParamsString() === '' ? '' : `?${this.setUTMParamsString()}`
      return `https://engage.b.ine.com/B2B-Contact-Us.html${UTMParamsString}`
    },
    BooGoHeroSectionImg() {
      return BooGoHeroSectionImgPng
    },
  },
}
</script>

<style lang="scss" scoped>
.boogo {
  $boogo_bg: '../../assets/images/hero-section/boogo/boogo_bg.png';
  &__section {
    width: 100%;
    background-color: var(--dark-purple-gradient-vertical);
    background-image: url(#{$boogo_bg}), var(--dark-purple-gradient-vertical) !important;
    background-position: bottom -15% right 35%;
    background-repeat: no-repeat;
    background-size: 100em;
    padding-top: 90px;
    top: -60px;
    position: relative;
    box-shadow: 0px 50px 21px 31px rgba(17, 17, 17);
    -webkit-box-shadow: 0px 50px 21px 31px rgba(17, 17, 17);
    -moz-box-shadow: 0px 50px 21px 31px rgba(17, 17, 17);
    @include mobile {
      background-position: bottom -1% right 50%;
    }
    @include desktop {
      padding-top: 60px;
      top: -60px;
      background-color: var(--dark-purple-gradient-horizontal);
      background-image: url(#{$boogo_bg}), var(--dark-purple-gradient-horizontal) !important;
      background-size: 175em;
      background-position: bottom -50% right 45%;
    }
    @include lg-desktop {
      background-position: bottom -50% right 43%;
    }
    @include lg-xl-desktop {
      background-position: bottom -50% right 25%;
    }
  }
  &__content {
    display: grid;
    grid-template-rows: auto 220px;
    @include mobile {
      grid-template-rows: auto 22em;
    }
    @include desktop {
      grid-template-columns: 45% 55%;
      grid-template-rows: auto;
      max-width: 1120px;
      margin: auto;
    }
    &-info {
      display: flex;
      flex-flow: column;
      text-align: center;
      z-index: 1;
      @include desktop {
        z-index: 0;
        justify-content: flex-start;
      }
      &-boogo-logo {
        align-self: center;
        margin-bottom: 10px;
      }
      &-text {
        color: #ef7d22;
        @include font-book;
        font-size: rem(18px);
        line-height: 22px;
        text-transform: uppercase;
        width: 80%;
        margin: 0 auto;
        @include mobile {
          width: 100%;
        }
      }

      &-button {
        text-decoration: none;
        width: 100%;
        max-width: 190px;
        margin: auto;
        @include mobile {
          width: unset;
          max-width: unset;
        }
        @include desktop {
          margin: 0 auto;
        }
        &--hide {
          display: none !important;
        }
      }
    }
  }
  &__discount {
    margin: 0 auto;
    scale: 0.6;
    max-width: 240px;
    overflow: visible;
    height: 80%;
    position: relative;
    top: -15px;
    left: -80px;
    @include mobile {
      scale: unset;
      max-width: unset;
      overflow: inherit;
      margin: auto;
      left: 0;
    }
    @include desktop {
      margin: 0 auto;
    }
    &-wrapper {
      display: flex;
      width: 100%;
      &--mb-40 {
        margin-bottom: 40px;
        @include mobile {
          margin-bottom: 0;
        }
      }
    }
  }
  &__lets-talk {
    color: var(--light-blue-gray);
    font-style: normal;
    font-weight: 500;
    font-size: rem(16px);
    line-height: rem(24px);
    text-align: center;
    margin: 30px auto;
    width: 80%;
    @include mobile {
      margin: 20px auto 60px auto;
      width: 100%;
    }
    &-link {
      color: var(--purple-pale);
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &__pumpkin {
    &-wrapper {
      text-align: center;
    }
    &-img {
      width: 100%;
      max-width: 480px;
      position: relative;
      top: -110px;
      @include mobile {
        max-width: 500px;
        top: -120px;
      }
      @include desktop {
        height: 500px;
        top: -35px;
        left: -5px;
      }
    }
  }
  &__actions {
    @include desktop {
      position: relative;
      top: -40px;
    }
  }
}
</style>
